module.exports = __webpack_public_path__ + "img/14.8bb0f279.png";